export default __webpack_public_path__ + "static/media/bulb.438d4ce0.svg";